import React, { FC, Ref, forwardRef } from "react";
import { IconButton, IconButtonProps, CircularProgress } from "@mui/material";

export type IwIconButtonProps = {
    loading?: boolean;
    showBorder?: boolean;
} & IconButtonProps;

type IwIconButtonRef = Ref<HTMLButtonElement>;

const IwIconButton: FC<IwIconButtonProps> = forwardRef(
    (props, ref: IwIconButtonRef) => {
        const {
            loading,
            children,
            disabled,
            showBorder,
            color,
            sx,
            ...otherProps
        } = props;

        return (
            <IconButton
                ref={ref}
                disabled={loading || disabled}
                color={color}
                sx={{
                    border: showBorder ? "1px solid" : "0px",
                    ".MuiSvgIcon-root:hover": {
                        color: `${color}.main`,
                    },
                    ".MuiSvgIcon-root": {
                        color: `${color}.main`,
                    },
                    ...sx,
                }}
                {...otherProps}
            >
                {loading ? <CircularProgress size={16} /> : children}
            </IconButton>
        );
    }
);

IwIconButton.defaultProps = {
    loading: false,
    showBorder: false,
    disabled: false,
    children: null,
    sx: {},
};

IwIconButton.displayName = "IwIconButton";

export default IwIconButton;
